// v-tip="{ title, body }" — hover description for chips on the IDENT/CHASSIS cards.
// A single tooltip element lives on <body> and is positioned from the chip's
// on-screen rect, so it isn't clipped by the cards' scroll containers or
// distorted by the carousel's 3D transforms.

let tipEl = null;

function tooltip() {
	if (!tipEl) {
		tipEl = document.createElement("div");
		tipEl.className = "lancer-tip";
		tipEl.hidden = true;
		document.body.appendChild(tipEl);
		// Anything that moves the chip out from under the tooltip hides it
		window.addEventListener("scroll", hide, true);
		window.addEventListener("resize", hide);
	}
	return tipEl;
}

function hide() {
	if (tipEl) tipEl.hidden = true;
}

function show(target) {
	const value = target._tipValue;
	if (!value || !value.body) return;
	const tip = tooltip();
	tip.replaceChildren();
	const title = document.createElement("div");
	title.className = "lancer-tip-title";
	title.textContent = value.title;
	const body = document.createElement("div");
	body.className = "lancer-tip-body";
	body.textContent = value.body;
	tip.append(title, body);
	tip.hidden = false;

	const gap = 8;
	const rect = target.getBoundingClientRect();
	const { width, height } = tip.getBoundingClientRect();
	const left = Math.min(
		Math.max(rect.left + rect.width / 2 - width / 2, gap),
		window.innerWidth - width - gap
	);
	const above = rect.top - height - gap;
	tip.style.left = `${left}px`;
	tip.style.top = `${above >= gap ? above : rect.bottom + gap}px`;
}

export default {
	mounted(el, binding) {
		el._tipValue = binding.value;
		el._tipShow = () => show(el);
		el.addEventListener("mouseenter", el._tipShow);
		el.addEventListener("mouseleave", hide);
		if (binding.value && binding.value.body) el.classList.add("has-tip");
	},
	updated(el, binding) {
		el._tipValue = binding.value;
		el.classList.toggle("has-tip", !!(binding.value && binding.value.body));
	},
	beforeUnmount(el) {
		el.removeEventListener("mouseenter", el._tipShow);
		el.removeEventListener("mouseleave", hide);
		hide();
	},
};
